      <button
        type="button"
        class="collapsible-rail-shell-app"
        aria-haspopup="menu"
        [attr.aria-expanded]="appContextMenuOpened()"
        [attr.aria-label]="'Switch app, currently ' + (app() | appTitle)"
        [appContextMenu]="app()"
        (appContextMenuChange)="handleAppChange($event)"
        (appContextMenuOpened)="appContextMenuOpened.set($event)"
      >
        <span class="collapsible-rail-shell-app-badge">
          <mat-icon class="collapsible-rail-shell-app-icon" [svgIcon]="app() | appIcon" />
        </span>

        <app-dropdown-label [collapsed]="!appContextMenuOpened()" class="font-semibold whitespace-nowrap">
          {{ app() | appTitle }}
        </app-dropdown-label>
      </button>
